<!--
    预约模块
-->
<template>
  <div class="appoint-box">
    <div class="appoint">
      <div class="appoint-form">
        <div class="input">
          <span>姓名</span>
          <input
            v-model="userName"
            class="fullInput mb-normal"
            type="text"
            placeholder="请输入姓名"
          />
        </div>
        <div class="input">
          <span>手机</span>
          <input
            v-model="userPhone"
            maxlength="11"
            class="fullInput mb-normal"
            type="text"
            placeholder="请输入手机"
          />
        </div>
        <div class="input select">
          <span>车型</span>
          <select
            @change="changeSeries"
            class="fullInput mb-normal"
            v-model="carType"
            name=""
            id=""
          >
            <option
              v-for="(item, index) in carSeriesList"
              :key="index"
              :value="item.value"
            >
              {{ item.name }}
            </option>
          </select>
        </div>
        <div class="selctBoth">
          <div>
            <select
              @change="changeProvince"
              class="fullInput mb-normal"
              v-model="provinceCode"
              name=""
              id=""
            >
              <option
                v-for="(item, index) in provinceList"
                :key="index"
                :value="item.value"
              >
                {{ item.name }}
              </option>
            </select>
          </div>
          <div>
            <select
              @change="changeCity"
              class="fullInput mb-normal"
              v-model="cityCode"
              name=""
              id=""
            >
              <option
                v-for="(item, index) in cityList"
                :key="index"
                :value="item.value"
              >
                {{ item.name }}
              </option>
            </select>
          </div>
        </div>
        <div class="input select">
          <span>经销商</span>
          <select class="fullInput" v-model="storeCode" name="" id="">
            <option
              v-for="(item, index) in storeList"
              :key="index"
              :value="item.value"
            >
              {{ item.name }}
            </option>
          </select>
        </div>
      </div>
      <checkbox v-model="checked"></checkbox>
      <div @click="submit" class="submit">
        <img
          src="https://source.qunarzz.com/site/images/wns/20221220-shijianchen-gift.png"
          class="giftIcon"
        />提交信息 抽取出游福利
      </div>
    </div>
  </div>
</template>
<script>
import checkbox from './checkbox';
import giftDialog from './dialog/gift/index';
import loginDialog from '@/components/login/index';
export default {
  components: {
    checkbox,
  },
  data() {
    return {
      userName: '',
      userPhone: '',
      storeCode: '',
      carType: '',
      checked: false,
      cityCode: '',
      provinceCode: '',
      defaultSelect: { name: '请选择', value: '' },
      carSeriesList: [],
      provinceList: [],
      cityList: [],
      storeList: [],
    };
  },
  created() {
    this.provinceList = [this.defaultSelect];
    this.carSeriesList = [this.defaultSelect];
    this.cityList = [this.defaultSelect];
    this.storeList = [this.defaultSelect];
    this.initCarSeriesList();
    this.initProvinceList();
  },
  methods: {
    changeSeries(e) {
      this.provinceCode = '';
      this.cityCode = '';
      this.storeCode = '';
      this.carType = e.target.value;
    },
    verifyForm() {
      return new Promise((resolve) => {
        var reg = /^1[3456789]\d{9}$/gi;
        let dialog = this.$dialog;
        if (!this.checked) {
          dialog.alert({
            message: '请勾选免责声明',
          });
        } else if (this.userName == '') {
          dialog.alert({
            message: '请输入姓名',
          });
        } else if (this.userPhone == '') {
          dialog.alert({
            message: '请输入手机号',
          });
        } else if (!reg.test(this.userPhone)) {
          dialog.alert({
            message: '请输入正确的手机号',
          });
        } else if (!this.carType) {
          dialog.alert({
            message: '请选择车型',
          });
        } else if (!this.provinceCode) {
          dialog.alert({
            message: '请选择省份',
          });
        } else if (!this.cityCode) {
          dialog.alert({
            message: '请选择城市',
          });
        } else if (!this.storeCode) {
          dialog.alert({
            message: '请选择经销商',
          });
        } else {
          resolve();
        }
      });
    },
    submit() {
      this.verifyForm().then(() => {
        let params = {
          province: this.provinceCode,
          // sex:'男',
          city: this.cityCode,
          phone: this.userPhone,
          name: this.userName,
          modelName: this.carType,
          modelCode: this.filterCode(),
          agent: this.storeCode,
        };
        this.$axios.post('/keepInfo/keepInfoAndLottery', params).then((res) => {
          if (res.code == 200) {
            giftDialog({
              type: res.data.code,
            });
          } else if (res.code == 400) {
            loginDialog({
              callback: () => {
                this.submit();
              },
            });
          } else {
            this.$dialog.alert({
              message: res.message,
            });
          }
        });
      });
    },
    initCarSeriesList() {
      this.$axios.get('/keepInfo/model').then((res) => {
        let carSeriesList = [this.defaultSelect];
        res.data.forEach((item) => {
          carSeriesList.push({
            name: item.modelName,
            code:item.modelCode,
            value: item.modelName,
          });
        });
        this.carSeriesList = carSeriesList;
      });
    },
    initProvinceList() {
      this.$axios.get('/keepInfo/provinces').then((res) => {
        let provinceList = [this.defaultSelect];
        res.data.forEach((item) => {
          provinceList.push({
            name: item,
            value: item,
          });
        });
        this.provinceList = provinceList;
      });
    },
    initCityList(province) {
      this.$axios.get('/keepInfo/cities?province=' + province).then((res) => {
        let cityList = [this.defaultSelect];
        res.data.forEach((item) => {
          cityList.push({
            name: item,
            value: item,
          });
        });
        this.cityList = cityList;
      });
    },
    initStoreList(cityId) {
      this.$axios
        .get(
          '/keepInfo/agents?province=' + this.provinceCode + '&city=' + cityId,
        )
        .then((res) => {
          let storeList = [this.defaultSelect];
          res.data.forEach((item) => {
            storeList.push({
              name: item,
              value: item,
            });
          });
          this.storeList = storeList;
        });
    },
    filterCode() {
      let code = "";
      this.carSeriesList.forEach((item, index) => {
        if (item.name == this.carType) {
          code = item.code;
        }
      });
      return code;
    },
    changeProvince(e) {
      this.cityCode = '';
      this.storeCode = '';
      this.provinceCode = e.target.value;
      this.initCityList(this.provinceCode);
    },
    changeCity(e) {
      this.storeCode = '';
      this.cityCode = e.target.value;
      this.initStoreList(this.cityCode);
    },
  },
};
</script>
<style lang="less" scoped>
* {
  box-sizing: border-box;
}
.appoint-box {
  position: relative;
  border-top: 1px solid transparent;
}
.rule-btn {
  border: 1px solid #1c3855;
  border-top-right-radius: 24px;
  border-bottom-right-radius: 24px;
  padding-left: 5px;
  padding-right: 15px;
  padding-top: 6px;
  padding-bottom: 6px;
  border-left: 0;
  font-size: 16px;
  position: absolute;
  left: 0;
  top: 3px;
  z-index: 10;
  cursor: pointer;
}
.appoint {
  padding-bottom: 20px;
  position: relative;
  width: 354px;
  background: #d69866;
  border-radius: 11px;
  margin:20px auto 0;
  padding:17px 17px 24px;
  &-form {
    input,
    select {
      display: block;
      border: none;
      outline: none;
      height: 37px;
      background-color: transparent;
      appearance: none;
      -moz-appearance: none;
      -webkit-appearance: none;
      color: #fff;
      text-align: center;
    }
    select{
      padding-right: 30px;
    }
    input::placeholder {
      color: #fff;
    }
    .fullInput {
      width: 100%;
    }
  }
}
.submit {
  width: 300px;
  height: 35px;
  background: #F2E8D4;
  color: #6B3929;
  border-radius: 18px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
}
.alignCenter {
  display: flex;
  align-items: center;
  justify-content: center;
}
.input {
  border: 1px solid #fff;
  border-radius: 18px;
  display: flex;
  align-items: center;
  margin-bottom: 16px;
  > span {
    width: 60px;
    .alignCenter();
    position: relative;
    &:after {
      content: '';
      display: block;
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-50%);
      height: 17px;
      width: 1px;
      background-color: #fff;
    }
    color: #fff;
  }
  .fullInput {
    width: calc(100% - 60px);
  }
}
.select {
  position: relative;
  &:after {
    content: '';
    display: block;
    position: absolute;
    right: 10px;
    top: 50%;
    transform: translateY(-50%);
    width: 16px;
    height: 10px;
    background: url(https://source.qunarzz.com/site/images/wns/20221128-shijianchen-linke-arrow.png)
      no-repeat;
    background-size: 100% auto;
  }
}
.selctBoth {
  display: flex;
  align-items: center;
  margin-bottom: 16px;
  justify-content: space-between;
  > div {
    position: relative;
    width: 149px;
    &:after {
      content: '';
      display: block;
      position: absolute;
      right: 10px;
      top: 50%;
      transform: translateY(-50%);
      width: 16px;
      height: 10px;
      background: url(https://source.qunarzz.com/site/images/wns/20221128-shijianchen-linke-arrow.png)
        no-repeat;
      background-size: 100% auto;
    }
  }
  .fullInput {
    border: 1px solid #fff;
    width: 149px;
    border-radius: 18px;
    position: relative;
  }
}
.giftIcon {
  width: 13px;
  margin-right: 5px;
}
</style>